import { useState } from 'react';
import useFetch from '../../../../hooks/useFetch';
import { ServiceEvents } from '../../shared/interfaces';
import { buildEndpointIntranetAdmin } from '../../EndPoints';

const useNotificationAdminService = () => {
    const { doGet, doPost } = useFetch();

    const [fetchingNotificationsNotViewed, setFetchingNotificationsNotViewed] = useState(false);
    const [fetchingNotificationsByUserRange, setFetchingNotificationsByUserRange] = useState(false);
    const [fetchingNotificationSetAsViewed, setFetchingNotificationSetAsViewed] = useState(false);

    const getNotificationsNotViewed = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin('notifications/notifications/not-viewed')}`,
            setFetching: setFetchingNotificationsNotViewed
        });
    };

    const getAllNotificationsByUserRange = (
        idNotification: number,
        quantity: number,
        events: ServiceEvents = {}
    ) => {
        const url = new URL(
            `${buildEndpointIntranetAdmin('notifications/notifications/by-user-range')}`
        );
        url.searchParams.append('id', idNotification.toString());
        url.searchParams.append('quantity', quantity.toString());
        doGet({
            ...events,
            type: 'admin',
            url: url.href,
            setFetching: setFetchingNotificationsByUserRange
        });
    };

    const setNotificationAsViewed = (idNotification: number, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            type: 'admin',
            url: `${buildEndpointIntranetAdmin(
                `notifications/notifications/${idNotification.toString()}/viewed`
            )}`,
            setFetching: setFetchingNotificationSetAsViewed
        });
    };
    return {
        getNotificationsNotViewed,
        fetchingNotificationsNotViewed,
        getAllNotificationsByUserRange,
        fetchingNotificationsByUserRange,
        setNotificationAsViewed,
        fetchingNotificationSetAsViewed
    };
};

export default useNotificationAdminService;
